export const extractDirtyData = (data, dirtyFields) => {
  const dirtyData = Object.keys(dirtyFields).reduce((acc, key) => {
    // For some reason, dirtyFields from react-hook-form
    // returns the key:boolean (false if not dirty)
    // so we need to check if the value is true
    if (dirtyFields[key]) {
      acc[key] = data[key];
    }
    return acc;
  }, {});

  return dirtyData;
};
